import api from "./api";

class SazonalidadeAPI {

  async getSazonalidades(headers, params) {
    const response = await api({
      method: 'post',
      url: '/get_sazonalidades',
      headers,
      data: params
    });
    return response;
  }

  async getProdutos(headers) {
    const response = await api.get("/get_produtos_sazonalidade", { headers });
    return response;
  }

  async storeSazonalidade(headers, params) {
    const response = await api({
      method: 'post',
      url: '/store_sazonalidade',
      headers,
      data: params
    });
    return response;
  }

  async getDadosExpanded(headers, params) {
    const response = await api({
      method: 'post',
      url: '/get_dados_expanded',
      headers,
      data: params
    });
    return response;
  }

  async getDadosExpandedHistorico(headers, params) {
    const response = await api({
      method: 'post',
      url: '/get_dados_expanded_historico',
      headers,
      data: params
    });
    return response;
  }

  async excluirSazonalidadeProdutos(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/excluir_sazonalidade_produtos',
      headers,
      data: params
    });

    return response;
  }

  async produtosPorFornecedor(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/produtos-por-fornecedor',
      headers,
      data: params
    });
    return response;
  }

  async getSazonalidadeSingleDialogPeriodo(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/get-sazonalidade-single-dialog-periodo',
      headers,
      data: params
    });
    return response;
  }

  async buscarMediaPeriodoSelecionado(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/buscar-media-periodo-selecionado',
      headers,
      data: params
    });
    return response;
  }

  async buscarDatasPeriodoProduto(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/buscar-datas-periodo-produto',
      headers,
      data: params
    });
    return response;
  }

  async excluirDatasPeriodoProduto(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/excluir-datas-periodo-produto',
      headers,
      data: params
    });
    return response;
  }

  async getMediaPeriodoData(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/get-media-periodo-data',
      headers,
      data: params
    });
    return response;
  }

  async alterarStatusAplicado(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/alterar-status-aplicado',
      headers,
      data: params
    });
    return response;
  }

  async verificarMultiDatas(headers, params) {
    const response = await api ({
      method: 'post',
      url: '/produtos/sazonalidades/verificar-multi-datas',
      headers,
      data: params
    });
    return response;
  }
}

export default new SazonalidadeAPI();
